import { Chart, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
export default defineNuxtPlugin((nuxtApp) => {
    // ????? nuxtApp is where vue.use should be otherwise it just runs on bootstrap and that's it ??????????
    // https://vueschool.io/lessons/injecting-plugins
    // example https://www.npmjs.com/package/vue-observe-visibility#installation
    // Vue.use(VueObserveVisibility) --> nuxtApp.vueApp.use(VueObserveVisibility)

    // this is just a global thing now so need to vue.use it
    Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
})